import { molecule } from "bunshi"
import { NftsSelectionScope } from "./nfts-selection-scope"

export const NftsSelectionMolecule = molecule((_, scope) => {
  const { selectedNftsAtom, toggleNftSelectionAction, selectionAvailable } =
    scope(NftsSelectionScope)

  return {
    selectedNftsAtom,
    selectionAvailable,
    // Keep old name for backward compatibility
    toggleNftSelectionAtom: toggleNftSelectionAction,
  }
})
